import React, { Component } from "react"
import { observer } from "mobx-react"
import styled from "styled-components"

import Spacer from "~/components/Spacer"
import withTranslations from "~/components/_hocs/withTranslations"
import DOBInput from "./DOBInput"
import ZipCodeInput from "./ZipCodeInput"
import InputTitle from "./InputTitle"
import DropdownMenu from "../DropdownMenu"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

@observer
class ZipCodeDobInput extends Component {
  render() {
    return (
      <Wrap>
        <InputTitle>
          {this.props.translate("label")}
          <Spacer direction="width" mobile={11} desktop={11} />
          <DropdownMenu columnNumber="one" />
        </InputTitle>
        <Spacer desktop={16} mobile={4} />
        <ZipCodeInput />
        <Spacer mobile={14} desktop={14} />
        <DOBInput />
      </Wrap>
    )
  }
}

export default withTranslations(ZipCodeDobInput, "form.traffic.zipCodeDOB")
